(function ($) {
    $(document).ready(function () {

      if ($("#bloggle_article #article #article-header .info_header").length) {
          $('.blog-reviewed_flag').appendTo('#bloggle_article #article #article-header .info_header');
          $('.blog-reviewed_flag').show();
      }


        $('a[href="#browse-sesisons"]').on('click', function (e) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: $('.section-virtual_group_consults:first').offset().top
          }, 1000);
        });
      
        var interval = setInterval(function() {
            // Check if the element exists
            $('.product__info-wrapper .bundle-widget .bndlr-inner-products-container .bndlr-product').each(function(){
                if ($(this).find('select').is(':visible')) {
                    $(this).addClass('has-variants');
                }
            });
            if ($('.product__info-wrapper .bundle-widget .bndlr-inner-products-container').length) {
                clearInterval(interval);
            }
        }, 100);

        // change product variant price
        $('.section-product_page .mobile-product-info-heading .col-right').on('DOMSubtreeModified', function(){
            jQuery('.section-product_page .desktop-product-info-heading .col-right').html(jQuery('.section-product_page .mobile-product-info-heading .col-right').html());
        });

        // change product bundle price
        $(document.body).on('change',".product__info-wrapper .bundle-widget .bndlr-inner-products-container .bndlr-product select",function (e) {
          setTimeout(function () {
            var bundle_old_price = jQuery('.product__info-wrapper .bundle-widget .bndlr-inner-products-container .bndlr-total-price .bndlr-old-price').text();
            var bundle_new_price = jQuery('.product__info-wrapper .bundle-widget .bndlr-inner-products-container .bndlr-total-price .bndlr-new-price').text();
            jQuery('.product__info-container .price--on-sale .price-item--regular').text(bundle_old_price);
            jQuery('.product__info-container .price--on-sale .price-item--sale').text(bundle_new_price);
            jQuery('.product__info-container .price__regular .price-item--regular').text(bundle_new_price);
            jQuery('.mobile-product-info-heading .price--on-sale .price-item--regular').text(bundle_old_price);
            jQuery('.mobile-product-info-heading  .price--on-sale .price-item--sale').text(bundle_new_price);
            jQuery('.mobile-product-info-heading .price__regular .price-item--regular').text(bundle_new_price);
          }, 300);
        });


      if ($(".banner-video").length) {
            $(document).on('click', '.banner-video .pause-video', function () {
                // Pause the video
                $('#hero-video').get(0).pause();
                $(this).attr('aria-label', 'Play Video');
                $(this).attr('class', 'video-trigger play-video');
                $(this).children('.icon-pause').hide();
                $(this).children('.icon-play').show();
            });
            $(document).on('click', '.banner-video .play-video', function () {
                // Play the video
                $('#hero-video').get(0).play();
                $(this).attr('aria-label', 'Pause Video');
                $(this).attr('class', 'video-trigger pause-video');
                $(this).children('.icon-play').hide();
                $(this).children('.icon-pause').show();
            });

        }


        // change product (variant) price on desktop
        jQuery(document.body).on('change','.section.section-product_page .product-ctas-wrapper .variant-picker>variant-radios .product-form__input input[type="radio"]',function (e) {
          setTimeout(function () {
            var variant_price_html = jQuery('.mobile-product-info-heading.product-info-heading .price').html();
            if (typeof variant_price_html !== 'undefined') {
              jQuery('.desktop-product-info-heading.product-info-heading .price').html(variant_price_html);
            }
          }, 300);
        });


        if ($('.shopify-policy__container').length) {
            var page_title  = $('.shopify-policy__container .shopify-policy__title h1').text();
            var url         = window.location.href;
            $('<div class="section-breadcrumbs"><div class="page-width"><nav class="breadcrumbs" role="navigation" aria-label="breadcrumbs"><ol><li><a href="/" title="Home">Home</a><svg class="icon-breadcrumbs" width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 1.5C0.5 0.84375 1.29688 0.515625 1.76562 1.00781L4.76562 3.98438C5.07031 4.26562 5.07031 4.75781 4.76562 5.03906L1.76562 8.01562C1.29688 8.48438 0.5 8.15625 0.5 7.5V1.5ZM4.25 4.5L1.25 1.5V7.5L4.25 4.5Z" fill="#182049"></path></svg></li><li><a href="'+url+'" aria-current="page">'+page_title+'</a><svg class="icon-breadcrumbs" width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 1.5C0.5 0.84375 1.29688 0.515625 1.76562 1.00781L4.76562 3.98438C5.07031 4.26562 5.07031 4.75781 4.76562 5.03906L1.76562 8.01562C1.29688 8.48438 0.5 8.15625 0.5 7.5V1.5ZM4.25 4.5L1.25 1.5V7.5L4.25 4.5Z" fill="#182049"></path></svg></li></ol></nav></div></div>').insertAfter('.shopify-policy__container .shopify-policy__title');
            
        }

        if ($('.featured-collection-slider').length) {
            $('.featured-collection-slider > .grid').slick({
                dots: false,
                // arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                nextArrow: '<a href="javascript:void(0);" role="button" class="arrows next"><svg width="17" height="6" viewBox="0 0 17 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4326 5.43236L15.8869 3.43696C15.936 3.40486 15.9764 3.36103 16.0043 3.30941C16.0322 3.2578 16.0469 3.20003 16.0469 3.14134C16.0469 3.08266 16.0322 3.02489 16.0043 2.97328C15.9764 2.92166 15.936 2.87783 15.8869 2.84573L12.4326 0.850332C12.3653 0.813815 12.2877 0.800739 12.2121 0.813165C12.1366 0.825592 12.0673 0.862814 12.0152 0.918964C11.9632 0.975114 11.9313 1.047 11.9246 1.12328C11.9178 1.19957 11.9367 1.27591 11.9782 1.34029L12.98 2.7992L0.389021 2.7992C0.298278 2.7992 0.211251 2.83524 0.147086 2.89941C0.0829219 2.96357 0.0468749 3.0506 0.0468749 3.14134C0.0468749 3.23209 0.0829219 3.31911 0.147086 3.38328C0.211251 3.44744 0.298278 3.48349 0.389021 3.48349L12.98 3.48349L11.9782 4.9424C11.9367 5.00678 11.9178 5.08312 11.9246 5.15941C11.9313 5.23569 11.9632 5.30757 12.0152 5.36372C12.0673 5.41987 12.1366 5.4571 12.2121 5.46952C12.2877 5.48195 12.3653 5.46887 12.4326 5.43236Z" fill="#434A4F"/></svg><span class="screen-reader-text">Next Slide</span></a>',
                prevArrow: '<a href="javascript:void(0);" role="button" class="arrows prev"><svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.6143 4.62376L0.159994 2.62837C0.110859 2.59627 0.0704988 2.55243 0.0425639 2.50082C0.014629 2.4492 1.04533e-07 2.39144 1.01968e-07 2.33275C9.94024e-08 2.27406 0.014629 2.2163 0.0425639 2.16468C0.0704988 2.11307 0.110859 2.06923 0.159994 2.03714L3.6143 0.0417383C3.68161 0.00522095 3.75916 -0.00785517 3.83473 0.00457133C3.91029 0.0169978 3.97957 0.0542202 4.03164 0.11037C4.08371 0.16652 4.11562 0.238404 4.12232 0.314688C4.12903 0.390973 4.11015 0.46732 4.06867 0.531692L3.06687 1.9906L15.6579 1.9906C15.7486 1.9906 15.8356 2.02665 15.8998 2.09082C15.964 2.15498 16 2.24201 16 2.33275C16 2.42349 15.964 2.51052 15.8998 2.57468C15.8356 2.63885 15.7486 2.6749 15.6579 2.6749L3.06687 2.6749L4.06867 4.13381C4.11015 4.19818 4.12903 4.27453 4.12232 4.35081C4.11562 4.4271 4.08372 4.49898 4.03164 4.55513C3.97957 4.61128 3.91029 4.6485 3.83473 4.66093C3.75916 4.67336 3.68161 4.66028 3.6143 4.62376Z" fill="#434A4F"/></svg><span class="screen-reader-text">Previous Slide</span></a>',
                responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3,
                    }
                },
                  {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 580,
                    settings: {
                    slidesToShow: 1,
                    }
                }
                ]
            });
            $('.featured-collection-slider > .grid').on('beforeChange', (e, s, cs, ns) => {
                const sc = s.$slides.length,
                    cls = 'slick-current slick-active' + (s.options.centerMode ? ' slick-center' : ''),
                    selector = ns === 0
                        ? `[data-slick-index="0"], [data-slick-index="${sc}"]`
                        : (ns === sc - 1 ? `[data-slick-index="-1"], [data-slick-index="${sc - 1}"]` : false);
                if (!selector) return;
                setTimeout(() => {
                    $('.slick-slide', s.$slider).removeClass(cls);
                    $(selector, s.$slider).addClass(cls);
                }, 10);
            });

            //featured collection slider filters
            var filters = [];
            i = 0;
            $('.section-featured_collection .collection-item').each(function() {
                if(jQuery.inArray($(this).data('collection'), filters) === -1 && $(this).data('collection') != 'undefined') {
                    filters[i++] = $(this).data('collection');
                }
            });
            $(".section-featured_collection .collection-menu-slider .collection-item").on('click', function(){
                var filter = $(this).data('collection');
                $(".featured-collection-slider > .grid").slick('slickUnfilter');
                $(".section-featured_collection .collection-menu-slider .collection-item").parent('li').removeClass('active');
                $(".section-featured_collection collection-menu-slider .collection-item").attr('aria-selected', false);
                $(this).parent('li').addClass('active');
                $(this).attr('aria-selected', true);
                for(var i=0;i<filters.length;i++) {
                    if(filter == filters[i]){
                        $(".featured-collection-slider > .grid").slick('slickFilter','.' + filters[i]);
                    }
                }
            });
        }

        //mobile footer description toogle
        
        $(".footer-description-section .mobile-trigger").on('click', function(){
            $(".footer_description_links, .footer_description_related, .description *:not(:first-child)").slideToggle();
        });
    

        if ($('.multicolumn-slider').length) {
            $('.multicolumn-slider').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1, 
                nextArrow: '<a href="javascript:void(0);" role="button" class="arrows next"><svg width="17" height="6" viewBox="0 0 17 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4326 5.43236L15.8869 3.43696C15.936 3.40486 15.9764 3.36103 16.0043 3.30941C16.0322 3.2578 16.0469 3.20003 16.0469 3.14134C16.0469 3.08266 16.0322 3.02489 16.0043 2.97328C15.9764 2.92166 15.936 2.87783 15.8869 2.84573L12.4326 0.850332C12.3653 0.813815 12.2877 0.800739 12.2121 0.813165C12.1366 0.825592 12.0673 0.862814 12.0152 0.918964C11.9632 0.975114 11.9313 1.047 11.9246 1.12328C11.9178 1.19957 11.9367 1.27591 11.9782 1.34029L12.98 2.7992L0.389021 2.7992C0.298278 2.7992 0.211251 2.83524 0.147086 2.89941C0.0829219 2.96357 0.0468749 3.0506 0.0468749 3.14134C0.0468749 3.23209 0.0829219 3.31911 0.147086 3.38328C0.211251 3.44744 0.298278 3.48349 0.389021 3.48349L12.98 3.48349L11.9782 4.9424C11.9367 5.00678 11.9178 5.08312 11.9246 5.15941C11.9313 5.23569 11.9632 5.30757 12.0152 5.36372C12.0673 5.41987 12.1366 5.4571 12.2121 5.46952C12.2877 5.48195 12.3653 5.46887 12.4326 5.43236Z" fill="#434A4F"/></svg><span class="screen-reader-text">Next Slide</span></a>',
                prevArrow: '<a href="javascript:void(0);" role="button" class="arrows prev"><svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.6143 4.62376L0.159994 2.62837C0.110859 2.59627 0.0704988 2.55243 0.0425639 2.50082C0.014629 2.4492 1.04533e-07 2.39144 1.01968e-07 2.33275C9.94024e-08 2.27406 0.014629 2.2163 0.0425639 2.16468C0.0704988 2.11307 0.110859 2.06923 0.159994 2.03714L3.6143 0.0417383C3.68161 0.00522095 3.75916 -0.00785517 3.83473 0.00457133C3.91029 0.0169978 3.97957 0.0542202 4.03164 0.11037C4.08371 0.16652 4.11562 0.238404 4.12232 0.314688C4.12903 0.390973 4.11015 0.46732 4.06867 0.531692L3.06687 1.9906L15.6579 1.9906C15.7486 1.9906 15.8356 2.02665 15.8998 2.09082C15.964 2.15498 16 2.24201 16 2.33275C16 2.42349 15.964 2.51052 15.8998 2.57468C15.8356 2.63885 15.7486 2.6749 15.6579 2.6749L3.06687 2.6749L4.06867 4.13381C4.11015 4.19818 4.12903 4.27453 4.12232 4.35081C4.11562 4.4271 4.08372 4.49898 4.03164 4.55513C3.97957 4.61128 3.91029 4.6485 3.83473 4.66093C3.75916 4.67336 3.68161 4.66028 3.6143 4.62376Z" fill="#434A4F"/></svg><span class="screen-reader-text">Previous Slide</span></a>',
                // autoplay: true,
                // autoplaySpeed: 5000,
                swipeToSlide: true, 
                touchThreshold: 100,
                responsive: [
                {
                    breakpoint: 990,
                    settings: {
                    slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 580,
                    settings: {
                        dots: true,
                        slidesToShow: 2,
                        arrows:false
                    }
                }
                ]
            });
            $('.multicolumn-slider').on('beforeChange', (e, s, cs, ns) => {
                const sc = s.$slides.length,
                    cls = 'slick-current slick-active' + (s.options.centerMode ? ' slick-center' : ''),
                    selector = ns === 0
                        ? `[data-slick-index="0"], [data-slick-index="${sc}"]`
                        : (ns === sc - 1 ? `[data-slick-index="-1"], [data-slick-index="${sc - 1}"]` : false);
                if (!selector) return;
                setTimeout(() => {
                    $('.slick-slide', s.$slider).removeClass(cls);
                    $(selector, s.$slider).addClass(cls);
                }, 10);
            });
        }


        //slider Testimonials
        if ($('.testimonials-slider-content').length) {
            $('.testimonials-slider-content').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: '<a href="javascript:void(0);" role="button" class="arrows next"><svg width="17" height="6" viewBox="0 0 17 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4326 5.43236L15.8869 3.43696C15.936 3.40486 15.9764 3.36103 16.0043 3.30941C16.0322 3.2578 16.0469 3.20003 16.0469 3.14134C16.0469 3.08266 16.0322 3.02489 16.0043 2.97328C15.9764 2.92166 15.936 2.87783 15.8869 2.84573L12.4326 0.850332C12.3653 0.813815 12.2877 0.800739 12.2121 0.813165C12.1366 0.825592 12.0673 0.862814 12.0152 0.918964C11.9632 0.975114 11.9313 1.047 11.9246 1.12328C11.9178 1.19957 11.9367 1.27591 11.9782 1.34029L12.98 2.7992L0.389021 2.7992C0.298278 2.7992 0.211251 2.83524 0.147086 2.89941C0.0829219 2.96357 0.0468749 3.0506 0.0468749 3.14134C0.0468749 3.23209 0.0829219 3.31911 0.147086 3.38328C0.211251 3.44744 0.298278 3.48349 0.389021 3.48349L12.98 3.48349L11.9782 4.9424C11.9367 5.00678 11.9178 5.08312 11.9246 5.15941C11.9313 5.23569 11.9632 5.30757 12.0152 5.36372C12.0673 5.41987 12.1366 5.4571 12.2121 5.46952C12.2877 5.48195 12.3653 5.46887 12.4326 5.43236Z" fill="#434A4F"/></svg><span class="screen-reader-text">Next Slide</span></a>',
                prevArrow: '<a href="javascript:void(0);" role="button" class="arrows prev"><svg width="16" height="5" viewBox="0 0 16 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.6143 4.62376L0.159994 2.62837C0.110859 2.59627 0.0704988 2.55243 0.0425639 2.50082C0.014629 2.4492 1.04533e-07 2.39144 1.01968e-07 2.33275C9.94024e-08 2.27406 0.014629 2.2163 0.0425639 2.16468C0.0704988 2.11307 0.110859 2.06923 0.159994 2.03714L3.6143 0.0417383C3.68161 0.00522095 3.75916 -0.00785517 3.83473 0.00457133C3.91029 0.0169978 3.97957 0.0542202 4.03164 0.11037C4.08371 0.16652 4.11562 0.238404 4.12232 0.314688C4.12903 0.390973 4.11015 0.46732 4.06867 0.531692L3.06687 1.9906L15.6579 1.9906C15.7486 1.9906 15.8356 2.02665 15.8998 2.09082C15.964 2.15498 16 2.24201 16 2.33275C16 2.42349 15.964 2.51052 15.8998 2.57468C15.8356 2.63885 15.7486 2.6749 15.6579 2.6749L3.06687 2.6749L4.06867 4.13381C4.11015 4.19818 4.12903 4.27453 4.12232 4.35081C4.11562 4.4271 4.08372 4.49898 4.03164 4.55513C3.97957 4.61128 3.91029 4.6485 3.83473 4.66093C3.75916 4.67336 3.68161 4.66028 3.6143 4.62376Z" fill="#434A4F"/></svg><span class="screen-reader-text">Previous Slide</span></a>',
                draggable: 'false',
                swipe: 'false',
                swipeToSlide: 'false',
                touchMove: 'false',
                draggable: 'false',
                fade: true,
                // asNavFor: '.testimonials-slider-images',
                // adaptiveHeight: true
            });
            $('.testimonials-slider-images').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.testimonials-slider-content',
                dots: true,
                arrows: false,
                infinite: true,
                focusOnSelect: true,
                centerMode: true,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        //Logos slider
        if ($('.logos-slider').length) {
            $('.logos-slider').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            variableWidth: true
                        }
                    }
                ]
            });

            $('.logos-slider').on('beforeChange', (e, s, cs, ns) => {
                const sc = s.$slides.length,
                    cls = 'slick-current slick-active' + (s.options.centerMode ? ' slick-center' : ''),
                    selector = ns === 0
                        ? `[data-slick-index="0"], [data-slick-index="${sc}"]`
                        : (ns === sc - 1 ? `[data-slick-index="-1"], [data-slick-index="${sc - 1}"]` : false);
                if (!selector) return;
                setTimeout(() => {
                    $('.slick-slide', s.$slider).removeClass(cls);
                    $(selector, s.$slider).addClass(cls);
                }, 10);
            });
        }

        if ($('.section-interactive_image .products-list').length) {
            mobileOnlySlider(".section-interactive_image .products-list", true, false, 767); 
        }

        // product-recommendations

        /* 
            Accordion Items
        */
        $(document).on("click", ".accordion-items .accordion-title", function (e) {

            e.preventDefault();

            if ($('.accordion-items .accordion-title').length > 1) {
                $(this).parent('.accordion-item').siblings().removeClass('open').attr('aria-expanded', false);
                $(this).parent('.accordion-item').siblings().children('.accordion-container').slideUp().attr('aria-hidden', true);
            }

            $(this).parent('.accordion-item').toggleClass('open');
            $(this).next('.accordion-container').slideToggle();

            if ($(this).parent('.accordion-item').hasClass('open')) {
                $(this).attr('aria-expanded', true);
                $(this).next('.accordion-container').attr('aria-hidden', false);
            } else {
                $(this).attr('aria-expanded', false);
                $(this).next('.accordion-container').attr('aria-hidden', true);
            }

        });

        $(document).on("click", ".close-resources-cta", function (e) {
            $('.resources-cta-wrapper').fadeOut();
        });

        $(document).on("click", ".add-to-cart-cta-trigger", function (e) {
            $('.quick-add-modal .product-ctas-wrapper .product-qty-buy-wrapper .product-buy-buttons .product-form .product-form__submit').click();
        });


        

        $(document).mouseup(function (e) {

            var interactive_image_product_container = $(".section-interactive_image .product-card-wrapper");    
            if (!interactive_image_product_container.is(e.target) && interactive_image_product_container.has(e.target).length === 0) {
                $('.section-interactive_image .product-card-wrapper').removeClass('ownflip');
                $('.section-interactive_image .product-trigger').removeClass('current');
            }

        });

        $(document).keyup(function (e) {
            if (e.key === "Escape") { // escape key maps to keycode `27`
                $('.section-interactive_image .product-card-wrapper').removeClass('ownflip');
                $('.section-interactive_image .product-trigger').removeClass('current');
            }
        });



        moveElementToLeft();



        $(".section-header .header__inline-menu .list-menu > li > header-menu > details").on({
            mouseenter: function () {
                $(this).attr('open','');
            },
            mouseleave: function () {
                $(this).removeAttr('open');
            }
        });
        
        if($('.blog-articles.related-blog-articles .blog-articles__article').length == 0) {
            $('.section-related-posts.main-blog').hide();
        }

      moveContentsOnMobile();
        
    });

    //event handler that prevents other handlers from executing when you click the mouse,
    onmousedown="if (event.preventDefault) event.preventDefault()"

    window.onpageshow = function (event) {
        if (event.persisted) {
            window.location.reload()

        }
    };

    $(window).on('load', function () {
        if($('.section-featured_collection .collection-menu-slider li:first .collection-item').length) {
            $(".featured-collection-slider > ul").slick('slickFilter','.' + $('.section-featured_collection .collection-menu-slider li:first .collection-item').data('collection'));
            $('.section-featured_collection .collection-menu-slider li:first').addClass('active');
            $('.section-featured_collection .collection-menu-slider li:first .collection-item').attr('aria-selected', true);
        }

        setTimeout(function(){
            if($('.resources-cta-wrapper').length) {
                $('.resources-cta-wrapper').addClass('active');
            }
            if($('.saving-cta-wrapper').length) {
                $('.saving-cta-wrapper').addClass('active');
            }

            if ($(".bggle--slider .bggle_product-container").length) {
            $('.bggle_product-container').each(function() {
              const titleText = $(this).find('.bloggle_product--title').text().trim();
              if (titleText) {
                $(this).find('.button').append('<span class="sr-only">' + titleText + '</span>');
              }
            });
          }
        },250);

        if (location.hash) {
            setTimeout(function () {
                hashTag = location.hash
                forcePageAction(hashTag);
            }, 500);
        }  
      
    });

    $(window).resize(function ($) {
        jQuery('.moveElementToLeft').each(function(){
            moveElementToLeft();
        });
        moveContentsOnMobile();
    });
    jQuery(window).on('orientationchange resize', function () {
        
        delay(function () {
            moveElementToLeft();
        }, 500);
    });

    $(window).scroll(function ($) {

    });


    document.addEventListener("DOMContentLoaded", function() {
      if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
        document.body.classList.add('is-mac');
      }
    });


    

})(jQuery);

var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

function moveContentsOnMobile() {
      if ($(window).width() <= 768) {
          $('.desktop-product-info-heading').children().appendTo('.mobile-product-info-heading');
      } else {
          $('.mobile-product-info-heading').children().appendTo('.desktop-product-info-heading');
      }
  }

function moveElementToLeft() {
    jQuery('.moveElementToLeft').each(function(){
        var element = $(this);
        element.css('left', '');
        var elementRight = element.offset().left + element.outerWidth();
        var viewportRight = $(window).scrollLeft() + $(window).width();
        if (elementRight > viewportRight) {
            var newLeft = viewportRight - elementRight;
            element.css('left', newLeft);
        } else {
            element.css('left', '');
        }
        
    });
}

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
        mobileFirst: true,
        dots: $dots,
        arrows: $arrows,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: $breakpoint,
                settings: "unslick"
            }
        ]
    };

    slider.not('.slick-initialized').slick(settings);

    $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
            return;
        }
        if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
        }
    });
}




const scroll_slider = document.querySelector('.parent-scroll-x');
let scroll_isDown = false;
let scroll_startX;
let scroll_scrollLeft;

const scroll_links = document.querySelectorAll('.scroll-item');
scroll_links.forEach(element => {element.addEventListener('mousedown',function(e) {
  e.preventDefault();
})
})


if(scroll_slider) {
  document.addEventListener('mousedown', (e) => {
    scroll_isDown = true;
    scroll_slider.classList.add('active');
    scroll_startX = e.pageX - scroll_slider.offsetLeft;
    scroll_scrollLeft = scroll_slider.scrollLeft;
  });
  document.addEventListener('mouseleave', () => {
    scroll_isDown = false;
    scroll_slider.classList.remove('active');
  });
  document.addEventListener('mouseup', () => {
    scroll_isDown = false;
    scroll_slider.classList.remove('active');
  });


  document.addEventListener('mousemove', (e) => {
    if(!scroll_isDown) return;
    e.preventDefault();
    const scroll_x = e.pageX - scroll_slider.offsetLeft;
    const scroll_walk = (scroll_x - scroll_startX) * 1; //scroll-fast
    scroll_slider.scrollLeft = scroll_scrollLeft - scroll_walk;
  });
}


function forcePageAction(elem) {

    scrollTo(elem);
}

function scrollTo(elem, speed) {
    if (jQuery(elem).length) {
        jQuery('body, html').animate({
            scrollTop: jQuery(elem).offset().top
        }, speed != "undefined" ? speed : 1500);
    }
}